<ui-asset [set]="'logos'" [name]="feature" />
@if (showTooltip && tooltipText) {
  <ui-product-tooltip [text]="tooltipText" />
}
